import React from 'react'
import {
  usePostAffiliateCreateNetworkMutation,
  usePostAffiliateUpdateMutation,
} from '../../../../app/api'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { DropOptions } from '../../../../shared/components/forms/drop-options/DropOptions'
import { setModal } from '../../../../app/store/reducers/AppSlice'
import { AddNetworkModal } from '../../widgets/add-network-modal/AddNetworkModal'
import { IconPlus } from '../../../../shared/components/icons/IconPlus'
import { IconPencil2 } from '../../../../shared/components/icons/IconPencil2'

interface NetworkCellProps {
  id: number
  network_name?: string | null
  network_value?: string | null
  network_id?: number
  project?: string
  networks?: any[]
  onRefetch: () => void
  onNetworksRefetch: () => void
}

export const NetworkCell = ({
  id,
  network_name,
  network_value,
  network_id,
  project,
  networks,
  onRefetch,
  onNetworksRefetch,
}: NetworkCellProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [updateNetwork] = usePostAffiliateUpdateMutation()
  const [createNetwork] = usePostAffiliateCreateNetworkMutation()

  return (
    <div className='flex flex-col justify-center gap-[4px]'>
      <DropOptions
        bottomSection={
          <button
            className={
              'flex w-full items-center justify-between px-[16px] py-[4px] text-[13px] text-default'
            }
            type={'button'}
            onClick={() =>
              dispatch(
                setModal({
                  size: 'md',
                  children: (
                    <AddNetworkModal
                      currentNetworks={[]}
                      onSubmit={(value) => {
                        createNetwork({
                          body: {
                            affiliate_id: id,
                            project_id: Number(project),
                            name: value,
                          },
                        }).then(() => {
                          onNetworksRefetch()
                          onRefetch()
                        })
                      }}
                    />
                  ),
                }),
              )
            }
          >
            {t('pages.PPCCompliance.buttons.addNewNetwork')}
            <div className={'w-[12px]'}>
              <IconPlus color={'#A059FF'} />
            </div>
          </button>
        }
        height={200}
        options={networks}
        value={String(network_id)}
        onChange={(e) => {
          updateNetwork({
            body: {
              scenario: e ? 'update_network' : 'remove_network',
              id,
              affiliate_network_id: Number(e),
            },
          }).then(() => onRefetch())
        }}
      >
        {network_name ? (
          <div className={'flex items-center gap-[4px] text-[15px]'}>
            <IconPencil2 className={'w-[10px]'} color={'#6684A7'} />
            {network_name}
          </div>
        ) : (
          <div className={'flex min-h-[24px] items-center'}>
            <IconPlus className={'w-[12px]'} color={'#6684A7'} />
          </div>
        )}
      </DropOptions>

      {network_value && <span className='text-[10px] leading-none'>{network_value}</span>}
    </div>
  )
}
